import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";
import { format, parseISO } from 'date-fns';

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

export const formatCurrency = (amount) => {
  if (amount === null || amount === undefined) return '₦0';
  return '₦' + Number(amount).toLocaleString('en-NG', {
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  });
};

export const formatDate = (dateString) => {
  if (!dateString) return '-';
  try {
    const date = typeof dateString === 'string' ? parseISO(dateString) : dateString;
    return format(date, 'dd MMM yyyy');
  } catch {
    return dateString;
  }
};

export const getStatusBadgeClass = (status) => {
  switch (status) {
    case 'Available':
      return 'badge-available';
    case 'Sold':
      return 'badge-sold';
    case 'Leased':
      return 'badge-leased';
    case 'Under Offer':
      return 'badge-under-offer';
    default:
      return 'bg-gray-900/30 text-gray-400 border border-gray-900/50';
  }
};

export const getAgentStatusBadgeClass = (status) => {
  return status === 'Active' 
    ? 'bg-green-900/30 text-green-400 border border-green-900/50'
    : 'bg-red-900/30 text-red-400 border border-red-900/50';
};

export const PROPERTY_TYPES = ['Land', 'Residential', 'Commercial', 'Industrial'];
export const PROPERTY_STATUSES = ['Available', 'Under Offer', 'Sold', 'Leased'];
export const SALE_TYPES = ['Outright Purchase', 'Installment Plan', 'Lease/Rental'];
export const SALE_SOURCES = ['MD Initiated', 'Agent Sale', 'Customer Referral'];
export const AGENT_STATUSES = ['Active', 'Inactive'];
export const PAYMENT_METHODS = ['Bank Transfer', 'Cash', 'Cheque', 'Mortgage'];
